import { useEffect, useState } from "react";
import { bemCN } from "../../config/bem-classname";
import { authService } from "../../services/auth-service";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import "./reg-page.scss";
import { SignInRequestDTO, SignUpRequestDTO } from "../../api/Api";
import { ReactComponent as MessageIcon } from "../../shared/images/svg/message.svg";
import { ReactComponent as UserIcon } from "../../shared/images/svg/user.svg";
import { ReactComponent as LockIcon } from "../../shared/images/svg/lock.svg";
import { Input, TypeDataInput, TypeViewInput } from "../../ui/input/input";
import { Link, useNavigate } from "react-router";
import { links } from "../../config/links";
import {
  emailHasError,
  nameHasError,
  passwordHasError,
} from "../../utils/validation-input";
import { Checkbox } from "../../ui/checkbox/checkbox";
import { MerticNames, sendMetrics } from "../../utils/metrics";

const regPageCn = bemCN("reg-page");

export const RegPage = () => {
  const navigate = useNavigate();
  const [newUser, setNewUser] = useState<SignUpRequestDTO>({
    username: "",
    surname: "",
    email: "",
    password: "",
  });
  const [isAgree, setIsAgree] = useState(false);
  const [isDisableButton, setIsDisableButton] = useState(false);
  const [errorText, setErrorText] = useState<string>();
  const onClickReg = () => {
    setErrorText(undefined);

    authService.registration(newUser).then((res: any) => {
      if (res == 200) {
        sendMetrics("reachGoal", MerticNames.registrationClick);
        navigate(links.login);
      } else {
        setErrorText(res);
      }
    });
  };

  useEffect(() => {
    if (
      !emailHasError(newUser.email) &&
      !nameHasError(newUser.username) &&
      !nameHasError(newUser.surname) &&
      !passwordHasError(newUser.password) &&
      isAgree
    ) {
      setIsDisableButton(true);
    } else {
      setIsDisableButton(false);
    }
  }, [newUser, isAgree]);

  return (
    <div className={regPageCn()}>
      <h1>Приветствуем вас в YUMI, Создайте аккаунт</h1>
      <div className={regPageCn("inputs")}>
        <Input
          onChange={(v: string) => setNewUser({ ...newUser, username: v })}
          icon={<UserIcon />}
          placeholder="Имя"
          value={newUser?.username}
          typeView={TypeViewInput.text}
          typeData={TypeDataInput.text}
          isValidate
        />
        <Input
          onChange={(v: string) => setNewUser({ ...newUser, surname: v })}
          icon={<UserIcon />}
          placeholder="Фамилия"
          value={newUser?.surname}
          typeView={TypeViewInput.text}
          typeData={TypeDataInput.text}
          isValidate
        />
        <Input
          onChange={(v: string) => setNewUser({ ...newUser, email: v })}
          icon={<MessageIcon />}
          placeholder="Email"
          value={newUser?.email}
          typeView={TypeViewInput.text}
          typeData={TypeDataInput.email}
          isValidate
        />
        <Input
          icon={<LockIcon />}
          placeholder="Пароль"
          value={newUser?.password}
          typeView={TypeViewInput.password}
          typeData={TypeDataInput.password}
          onChange={(v: string) => setNewUser({ ...newUser, password: v })}
          isValidate
        />
      </div>
      <div className={regPageCn("checkbox")}>
        <Checkbox onClick={() => setIsAgree(!isAgree)} isCheck={isAgree} />
        <p>
          <span>Продолжая, Вы соглашаетесь с нашей </span>
          <Link to={links.policy}>Политикой конфиденциальности</Link> и{" "}
          <Link to={links.rules}>Правилами использования</Link>
        </p>
      </div>
      <Button
        onClick={onClickReg}
        text="Зарегистрироваться"
        color={ButtonColors.violet}
        size={ButtonSizes.big}
        noDisabled={!isDisableButton}
      />
      {errorText && <p>{errorText}</p>}
      <div className={regPageCn("login")}>
        <p>
          Уже есть аккаунт? <Link to={links.login}>Войти</Link>
        </p>
      </div>
    </div>
  );
};
